import { css } from '@emotion/react';
import { MessageContainerProps } from '.';
import { MessagePosition } from './types';

export function getContainerStyle({ position, offset_x, offset_y }: MessageContainerProps) {
  switch (position) {
    case MessagePosition.TOP_CENTER:
      return css`
        align-items: center;
        top: ${offset_y}px;
        left: 50%;
        transform: translateX(-50%);
      `;
    case MessagePosition.TOP_RIGHT:
      return css`
        align-items: flex-end;
        top: ${offset_y}px;
        right: ${offset_x}px;
      `;
    case MessagePosition.BOTTOM_CENTER:
      return css`
        align-items: center;
        bottom: ${offset_y}px;
        left: 50%;
        transform: translateX(-50%);
      `;
    case MessagePosition.BOTTOM_RIGHT:
      return css`
        align-items: flex-end;
        bottom: ${offset_y}px;
        right: ${offset_x}px;
      `;
    case MessagePosition.CENTER:
      return css`
        align-items: center;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      `;
  }
}
